import type { OnboardingStepItem } from '../types/onboarding';

/**
 * Passos do checklist excluídos do tour guiado até a feature existir.
 * WHATSAPP_CHANNEL — opt-in de chatbot; reativar quando a integração estiver disponível.
 */
export const ONBOARDING_TOUR_EXCLUDED_STEP_IDS: readonly string[] = ['WHATSAPP_CHANNEL'];

/** Alvos do tour WHATSAPP_CHANNEL — preservados para reativação futura (chatbot). */
export const WHATSAPP_CHANNEL_ONBOARDING_STEP_TARGETS = [
  {
    id: 'WHATSAPP_CHANNEL__WHATSAPP',
    hint: 'Informe o número de WhatsApp com DDD para que clientes possam entrar em contato.',
  },
  {
    id: 'WHATSAPP_CHANNEL__SAVE',
    hint: 'Clique em Salvar Redes Sociais para confirmar o canal de WhatsApp.',
  },
] as const;

export function isOnboardingTourStepEnabled(stepId: string): boolean {
  return !ONBOARDING_TOUR_EXCLUDED_STEP_IDS.includes(stepId);
}

export function filterTourSteps(steps: OnboardingStepItem[]): OnboardingStepItem[] {
  return steps.filter((step) => isOnboardingTourStepEnabled(step.id));
}
